import { render } from "./Wait.vue?vue&type=template&id=662fd04b&scoped=true"
import script from "./Wait.vue?vue&type=script&lang=js"
export * from "./Wait.vue?vue&type=script&lang=js"

import "./Wait.vue?vue&type=style&index=0&id=662fd04b&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662fd04b"]])

export default __exports__